<script>
import FilArianne from './fil-arianne';
import QuestionnaireSatisfaction from './questionnaire-satisfaction';

export default {
  name: 'ConfirmCommande',
  components: {
    FilArianne,
    QuestionnaireSatisfaction
  },
  props: {
    numero: {
      type: String,
      default: null
    },
    mail: {
      type: String,
      default: null
    }
  },
  computed: {
    mailAdress () {
      return this.mail ? this.mail.trim() : null;
    },
    mailAdressHtml () {
      const mail = this.mail ? this.mail.trim() : '';
      return '<span>' + mail.replace('@', '</span><span>@') + '</span>';
    }
  },
  methods: {
    retourAccueil () {
      this.$router.push({ name: 'main.catalog' });
    }
  }
};
</script>

<template>
  <div>
    <FilArianne :step="3" />

    <div class="confirm-commande-container">
      <div class="confirm-commande-content">
        <v-icon size="3em">
          mdi-email-check-outline
        </v-icon>
        <br>
        <p> Votre commande<span v-if="numero"> N°<b>{{ numero }}</b></span> a bien été enregistrée</p>
        <div
          v-if="mailAdress"
        >
          Une confirmation vous a été envoyée à l'adresse :
          <!-- eslint-disable vue/no-v-html -->
          <strong
            class="email"
            v-html="mailAdressHtml"
          />
          <!-- eslint-enable vue/no-v-html -->
        </div>

        <v-btn
          outlined
          class="mt-3"
          @click="retourAccueil()"
        >
          Retour à l'accueil
        </v-btn>
      </div>
      <QuestionnaireSatisfaction
        class="mt-8"
        :numero-commande="numero"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.confirm-commande-container{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: calc(100vh - 8vw - 182px);
}

.confirm-commande-content{
  font-size: 1.7em;
  text-align: center;
  max-width: 100%;
  .v-icon{
    font-size: 1em;
  }
}

.email{
  word-break: break-all;
  display: inline-block;
  ::v-deep *{
    display: inline-block;
  }
}
</style>
